import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full mt-6 overflow-x-auto" }
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_4 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_5 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_6 = { class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_7 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }

import { ref } from "vue";
    import SortableTableHeader from "@/components/tables/SortableTableHeader.vue";
    import PaginationBar from "@/components/PaginationBar.vue";
    import { useRoute } from "vue-router";

    import api from "@/api/api";
    import { PaginationMeta } from "@/types";
    import { useFilters } from "@/composables/filters";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ClubSurveyTable',
  props: {
        title: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: false,
        },
     },
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;

    const route = useRoute();

    const { filters, sortBy, getFiltersFromQuery, setFilterNoRefresh } = useFilters(route);

    const items = ref([]);
    const meta = ref({} as PaginationMeta);

    

    async function getSatisfaction() {
        getFiltersFromQuery();
        if(props.type) setFilterNoRefresh("type", props.type);
        const response = await api.surveys.getSurveySatifactionClubs(filters.value);
        meta.value = response?.meta;
        items.value = response?.data;
    }

    if (!route.query.page) setFilterNoRefresh("page", "1");

    ;(
  ([__temp,__restore] = _withAsyncContext(() => getSatisfaction())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            _createElementVNode("th", _hoisted_4, [
              _createTextVNode(_toDisplayString(props.title) + " ", 1),
              _createVNode(SortableTableHeader, {
                column: "name",
                onSort: _unref(sortBy)
              }, null, 8, ["onSort"])
            ]),
            _createElementVNode("th", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t("member-session-average")) + " ", 1),
              _createVNode(SortableTableHeader, {
                column: "score",
                onSort: _unref(sortBy)
              }, null, 8, ["onSort"])
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray",
              key: item.name
            }, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(item.name), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(item.rating), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
  ], 64))
}
}

})